// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ZMSy","content":"styles_content__2ovD-","tableWrap":"styles_tableWrap__27fRl"};